import React from 'react';
import { Icon } from './Icon.js';
export const IconChartRadar = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M18 21H6L2 10L12 2L22 10L18 21Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M9 15.5L7.5 11.5L12 9L16 11L15 15L9 15.5Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChartRadar.js.map